import {
  AggregatedOrderedProject,
  useSummedOrderedProjects,
} from '~/common/api/orderingServiceApi/OrderingApi';
import _ from 'lodash';

export function useImportant() {
  const { data: summedOrderedProjects = [] } = useSummedOrderedProjects();
  const orderedProjects = summedOrderedProjects.flatMap(
    (sop) => sop.orderedProjects,
  );
  const uncheckedDone = orderedProjects.filter(
    (op) => op.doneAmount >= op.amount && !op.checkedIn,
  ).length;
  const uncheckedPartiallyDone = orderedProjects.filter(
    (op) => op.doneAmount > 0 && op.doneAmount < op.amount && !op.checkedIn,
  ).length;
  return {
    uncheckedPartiallyDone,
    uncheckedDone,
  };
}

export function useOrderedProjectTimes() {
  const { data: summedOrderedProjects = [] } = useSummedOrderedProjects();
  const totalSeconds = _.sum(
    summedOrderedProjects
      .flatMap((op) => op.orderedProjects)
      .map((op) => calculatedProjectTime(op)),
  );

  const openSeconds = _.sum(
    summedOrderedProjects
      .flatMap((op) => op.orderedProjects)
      .map((op) => calcultedOpenProjectTime(op)),
  );

  return { totalSeconds, openSeconds };
}

function calculatedProjectTime(
  orderedProject: AggregatedOrderedProject,
): number {
  const time =
    (orderedProject.project?.calculated_project_time ?? 0) *
    orderedProject.amount;
  const optionTime = _.sum(
    orderedProject.options.map((op) => calculatedProjectTime(op)),
  );
  return time + optionTime;
}

function calcultedOpenProjectTime(orderedProject: AggregatedOrderedProject) {
  const time =
    (orderedProject.project?.calculated_project_time ?? 0) *
    max(orderedProject.amount - orderedProject.doneAmount, 0);
  const optionTime = _.sum(
    orderedProject.options.map((op) => calcultedOpenProjectTime(op)),
  );
  return time + optionTime;
}

function max(a: number, b: number) {
  if (a >= b) return a;
  return b;
}
